// Thermal/label printer presets (dimensions in mm). w/h = 0 means on-screen grid (A4).
export const LABEL_PRESETS = [
  { id: "std", label: "A4 sheet (screen grid)", w: 0, h: 0 },
  { id: "brother-dk11201", label: "Brother DK-11201 · 29×90mm", w: 90, h: 29 },
  { id: "brother-dk11209", label: "Brother DK-11209 · 29×62mm", w: 62, h: 29 },
  { id: "brother-dk11208", label: "Brother DK-11208 · 38×90mm", w: 90, h: 38 },
  { id: "brother-dk22205", label: "Brother DK-22205 · 62mm tape", w: 90, h: 62 },
  { id: "zebra-51x25", label: "Zebra · 51×25mm", w: 51, h: 25 },
  { id: "zebra-57x32", label: "Zebra · 57×32mm", w: 57, h: 32 },
  { id: "zebra-76x51", label: "Zebra · 76×51mm", w: 76, h: 51 },
  { id: "custom", label: "Custom…", w: 60, h: 30 },
];

export const getPreset = (id) => LABEL_PRESETS.find((p) => p.id === id) || LABEL_PRESETS[0];

// QR pixel size that fits a label of given mm height (1mm ≈ 3.78px), clamped.
export const qrPx = (w, h) => {
  if (!w || !h) return 78;
  return Math.max(40, Math.min(130, Math.round((Math.min(w, h) - 6) * 3.4)));
};

// Auto-adjust which fields show and how big the text is, based on label size (mm).
// Returns px font sizes + visibility flags so tiny thermal labels stay legible.
export const labelLayout = (w, h) => {
  const qr = qrPx(w, h);
  if (!w || !h) return { tier: "full", qr: 78, name: 14, code: 16, meta: 11, accent: 10, pad: 12, gap: 12, showMeta: true, showSecondary: true, showAccent: true };
  const minDim = Math.min(w, h);
  const area = w * h;
  if (minDim < 27 || area < 1500) {
    return { tier: "tiny", qr, name: 8.5, code: 11, meta: 7, accent: 7, pad: 4, gap: 5, showMeta: true, showSecondary: false, showAccent: false };
  }
  if (minDim < 40 || area < 2800) {
    return { tier: "small", qr, name: 10.5, code: 13, meta: 8.5, accent: 8, pad: 6, gap: 8, showMeta: true, showSecondary: false, showAccent: true };
  }
  return { tier: "large", qr, name: 13, code: 15, meta: 10, accent: 9, pad: 8, gap: 10, showMeta: true, showSecondary: true, showAccent: true };
};

// A <style> string that makes each label its own correctly-sized page when printing.
export const labelPrintCss = (w, h) => {
  if (!w || !h) return "";
  return `@media print {
    @page { size: ${w}mm ${h}mm; margin: 1.5mm; }
    .tag-sheet { display: block !important; }
    .tag-card { width: ${w}mm !important; height: ${h}mm !important; margin: 0 !important;
      page-break-after: always; break-after: page; overflow: hidden; box-shadow: none !important; }
  }`;
};
